"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBSearchBar;
var _react = _interopRequireDefault(require("react"));
var _Search = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/Search.svg"));
var _arrowLeft = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/arrow-left.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//this is used in FAQ landing page need to revisit the design and remove or updated this comp

function SVBSearchBar(props) {
  const {
    onsearchTermChange,
    handleSubmit,
    enableSubmit,
    placeHolderData,
    value,
    setValue
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "searchbar-wrap searchbar-no-radius searchbar_large d-flex"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _Search.default,
    alt: "search icon",
    role: "presentation",
    width: "24",
    height: "24"
  }), /*#__PURE__*/_react.default.createElement("input", {
    value: value,
    type: "search",
    id: "searchInputFormControl",
    className: "searchbar_control",
    placeholder: placeHolderData ? placeHolderData : "Search through API Docs, Solutions and more...",
    required: true,
    onChange: e => {
      /* istanbul ignore next */
      setValue(e.target.value);
      /* istanbul ignore next */
      onsearchTermChange(e);
    }
  }), /*#__PURE__*/_react.default.createElement("button", {
    disabled: enableSubmit ? false : true,
    className: "submit-search",
    name: "submit",
    type: "submit",
    onClick: e => handleSubmit(e)
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _arrowLeft.default,
    alt: "arrow icon",
    role: "submit",
    width: "14",
    height: "16"
  })));
}